"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../keyFactory");
/**
 * Permite obtener un appointment dado su id
 */
function useSpecialistAppointment(firestore, country, type, assignation_id, firestoreQueryOptions, reactQueryOptions) {
    const appointmentRef = (0, firestore_2.doc)(firestore, `assignations/${type}/${process.env.NEXT_PUBLIC_COUNTRY}/${assignation_id}`);
    return (0, firestore_1.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.Especialista({
        name: "SpecialistAppointment",
        path: `assignations/${type}/${process.env.NEXT_PUBLIC_COUNTRY}/${assignation_id}`
    }, [country, type, assignation_id]), appointmentRef, firestoreQueryOptions, reactQueryOptions);
}
exports.default = useSpecialistAppointment;
